import { onUnmounted, ref, type Ref, provide, computed } from 'virtual-vue';
import { useStepInject, STEP_INJECT_KEY, StepItemIndex } from './provide';
import type { StepDirection } from './step';

/**
 * 步骤 Hook
 * 主要用于提供步骤条的方向、当前激活步骤索引和流程是否连贯
 * @param props Step 组件的 props
 * @returns
 */
export function useStep(props) {
  const direction = computed<StepDirection>(() => props.direction ?? 'horizontal');
  const active = computed<number>(() => Math.max(props.active ?? 0, 0));
  const flow = computed<boolean>(() => props.flow ?? true);

  provide(STEP_INJECT_KEY, {
    direction,
    active,
    flow,
    // 用于在步骤项组件中获取当前步骤项的索引
    indexMgr: new StepItemIndex(),
  });

  return {
    direction,
    active,
    flow,
  };
}

/**
 * 步骤项 Hook
 * 主要用于获取当前步骤项的索引，并管理步骤项的索引
 * @returns {Object} 步骤项 Hook 返回对象
 */
export function useStepItem() {
  const { direction, active, flow, indexMgr } = useStepInject();
  /** 步骤项唯一标识，用于后续在步骤项组件中获取当前步骤项的索引 */
  const itemKey = Symbol();
  const stepIndex: Ref<number> = ref(indexMgr.getItemIndex(itemKey));

  onUnmounted(() => {
    indexMgr.clearItem(itemKey);
  });

  return {
    direction,
    stepIndex,
    active,
    flow,
  };
}
